import useAppLanguage from "@/components/Root/hooks/useAppLanguage";
import useApplyPromoCodeFromParam from "@/components/Root/hooks/useApplyPromoCodeFromParam";
import useAuthRedirectPath from "@/components/Root/hooks/useAuthRedirectPath";
import useAuthTokenCheck from "@/components/Root/hooks/useAuthTokenCheck";
import useCountryCode from "@/components/Root/hooks/useCountryCode";
import useLoadTimeCountdown from "@/components/Root/hooks/useLoadTimeCountdown";
import useLogoutParam from "@/components/Root/hooks/useLogoutParam";
import usePricingDisplayData from "@/components/Root/hooks/usePricingDisplayData";
import useRouteHandle from "@/components/Root/hooks/useRouteHandle";
import useUserProfile from "@/components/Root/hooks/useUserProfile";
import UILoader from "@/components/ui/Loader";
import useControlIntercom from "@/hooks/useHideIntercom";
import { Navigate, Outlet } from "@/lib/router";
import { usePageTracking } from "@/tracking/usePageTracking";
import { useSigninCheck } from "reactfire";

const AppLayout = () => {
  const { status, data } = useSigninCheck();
  const { getRoutePath } = useAuthRedirectPath();
  const { checkingToken } = useAuthTokenCheck();
  const isUserLoading = useUserProfile();
  const { timeRemaining } = useLoadTimeCountdown();
  const { hideIntercom } = useRouteHandle();

  useControlIntercom(hideIntercom === true);
  useApplyPromoCodeFromParam();
  usePageTracking();
  useCountryCode();
  useAppLanguage();
  usePricingDisplayData();
  useLogoutParam();
  // useV1Redirect();

  if (
    status === "loading" ||
    (isUserLoading && data.signedIn) ||
    checkingToken ||
    timeRemaining > 0
  ) {
    return <UILoader />;
  }

  // Redirect to auth if not signed in
  if (!data?.signedIn) {
    return <Navigate to={getRoutePath()} replace />;
  }

  return <Outlet />;
};

export default AppLayout;
